import * as ActionTypes from './actionTypes'
import { BASE_URL } from '../constants'

const LOGIN_SERVICE_URL = `${BASE_URL}api/auth`

const getLocation = async () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => resolve({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      })
        , reject)
    } else {
      reject('Geolocation is not supported by this browser')
    }
  })
}

export const login = (username, password) => async dispatch => {
  dispatch({ type: ActionTypes.LOGIN_START })

  const { latitude, longitude } = await getLocation().catch(() => {
    return { latitude: null, longitude: null }
  })

  try {
    const response = await fetch(LOGIN_SERVICE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username,
        password,
        latitude,
        longitude
      })
    })

    if (response.ok) {
      const result = await response.json()
      dispatch({
        type: ActionTypes.LOGIN_SUCCESS,
        token: result.token,
        user: {
          username: result.username,
          name: result.name,
          isAdmin: result.isAdmin,
          preferences: result.preferences,
          permissions: result.permissions
        }
      })
    } else {
      dispatch({
        type: ActionTypes.LOGIN_FAIL,
        error: 'Username and password do not match'
      })
    }
  } catch (exception) {
    dispatch({ type: ActionTypes.LOGIN_FAIL, error: exception })
  }
}

export const logout = () => ({
  type: ActionTypes.LOGOUT
})

export const init = ({ token, user }) => ({
  type: ActionTypes.INIT,
  token,
  user
})
